import Header from '@gaia/components/header-ui';
import {OutsideAnnouncement} from '@gaia/components/header-ui/OutsideAnnouncement';
import theme from '@gaia/theme';
import {StyledEngineProvider, ThemeProvider} from '@mui/material/styles';
import {render} from 'react-dom';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';

declare global {
    interface Window {
        HeaderUI: {
            initialize: (
                isMigratedRivtUser: boolean,
                hasActiveOutsidePlusSubscription: boolean
            ) => void;
        };
    }
}

window.HeaderUI = {
    initialize(isMigratedRivtUser, hasActiveOutsidePlusSubscription) {
        const headerContainer = document.querySelector('#base_header');
        const bannerContainer = document.querySelector('#base_banner');

        if (headerContainer) {
            render(
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_SITE_KEY!}>
                            <Header />
                        </GoogleReCaptchaProvider>
                    </ThemeProvider>
                </StyledEngineProvider>,
                headerContainer
            );
        }

        if (bannerContainer) {
            render(
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <OutsideAnnouncement
                            isMigratedRivtUser={isMigratedRivtUser}
                            hasActiveOutsidePlusSubscription={hasActiveOutsidePlusSubscription}
                        />
                    </ThemeProvider>
                </StyledEngineProvider>,
                bannerContainer
            );
        }
    },
};
